  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span> 
    <p>Select & Add Participant</p>   
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="radOpts">

      <mat-form-field>
        <mat-label>Type of Participant</mat-label>
        <mat-select (selectionChange)="onSelectParticpant($event)" [(ngModel)]="typeOfParticipant">
          <mat-select-trigger>
              {{ textNameShow }}
          </mat-select-trigger>
          <ng-container *ngFor="let participant of typeofParticipantList">
            <mat-option [value]="participant.value">
              <mat-icon *ngIf="participant.icon">{{ participant.icon }}</mat-icon>
              {{ participant.name }}
            </mat-option>
          </ng-container>
          
          <!-- <mat-option [value]="0">
              <mat-icon>email</mat-icon> Email
          </mat-option>
          <mat-option [value]="4">
            <mat-icon>person</mat-icon>User
          </mat-option>
          <mat-option [value]="5">
            <mat-icon>work</mat-icon>Role
          </mat-option>
          <mat-option *ngIf="CoreShowName!=''" [value]="1">
            <mat-icon>app_registration</mat-icon>{{CoreShowName}}
          </mat-option>
          <mat-option *ngIf="ContactShowName!=''" [value]="2">
            <mat-icon>contact_mail</mat-icon>{{ContactShowName}}
          </mat-option>
          <mat-option *ngIf="CompanyShowName!=''" [value]="3">
            <mat-icon>business</mat-icon>{{CompanyShowName}}
          </mat-option> -->
        </mat-select>   
      </mat-form-field>

    </div>

    <div class="block mt-10" *ngIf="ShowEmailBox">
      <div class="relative">
        <mat-form-field appearance="outline" >
          <input matInput maxlength="100" class="form-control mtb-15" placeholder="Add email"
            [(value)]="emailAssigned" (input)="emailCheck($event.target.value)" />
        </mat-form-field>

        <button 
        color="primary"
         *ngIf="addEmailButtonShow"
          (click)="addEmail()" mat-icon-button
          class="addBtn"
          >
          <mat-icon>add</mat-icon>
        </button>
      </div>
      
    </div>    

    <div class="block mt-10" *ngIf="ShowUserBox">
      <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search user</mat-label>
        <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
          (input)="searchUser($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="userSelectedNew(user)" *ngFor="let user of sharedAccessUserList" [value]="user.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                <img *ngIf="user.profileImagePath!=''" src="{{user.profileImagePath}}" alt="">
                <span class="username" *ngIf="user.profileImagePath==''" class="username">
                  {{user.shortName}}
                </span>
              </div>
              <div class="info">
                <p> {{ user.firstName }} {{ user.lastName }}</p>
                <p class="email">{{ user.email }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>      
    </div>

    <div class="block mt-10" *ngIf="ShowRoleBox">
      <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search role</mat-label>
        <input matInput maxlength="50" placeholder="Search role" aria-label="State" [matAutocomplete]="auto"
          (input)="getSharedAccessRoles($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="roleSelectedNew(obj)" *ngFor="let obj of sharedAccessRoleList" [value]="obj.roleName">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="info">
                <p> {{ obj.roleName }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
      
    </div>   

    <div class="block mt-10" *ngIf="ShowCoreBox">
      <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search {{CoreShowName}}</mat-label>
        <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
          (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="coreSelectedNew(core)" *ngFor="let core of attachedToCoreList"
            [value]="core.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                <span class="username" *ngIf="core.imageUrl==''" class="username">
                  {{core.shortName}}
                </span>
              </div>
              <div class="info">
                <p> {{ core.name }}</p>
                <p class="email">{{ core.email }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
      
    </div>

    <div class="block mt-10" *ngIf="ShowContactBox">
      <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search {{ContactShowName}}</mat-label>
        <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
          (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="contactSelectedNew(contact)"
            *ngFor="let contact of contactsList" [value]="contact.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                <span class="username" *ngIf="contact.imageUrl==''" class="username">
                  {{contact.shortName}}
                </span>
              </div>
              <div class="info">
                <p> {{ contact.name }}</p>
                <p class="email">{{ contact.email }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
     
    </div>

    <div class="block mt-10" *ngIf="ShowCompanyBox">
      <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search {{CompanyShowName}}</mat-label>
        <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
          (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="companySelectedNew(company)"
            *ngFor="let company of CompanyList" [value]="company.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                <span class="username" *ngIf="company.imageUrl==''" class="username">
                  {{company.shortName}}
                </span>
              </div>
              <div class="info">
                <p> {{ company.name }}</p>
                <p class="email">{{ company.email }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
     
    </div>

    <ul class="selectedlist">
      <li *ngFor="let ass of addUpdateParticipantList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
            <span *ngIf="ass.img==''" class="username">
              {{ass.shortName}}
            </span>
          </div>
          <div class="details">
            <h4>{{ass.name}}</h4>
            <p>{{ass.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button matTooltip="Remove">
              <mat-icon (click)="removeParticipant(ass)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    

  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" 
      (click)="onAddParticipant()" color="primary" [disabled]="showAddButton == true">
      <mat-icon *ngIf="spinner">
        <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
      Done
    </button>  
   
  </mat-dialog-actions>


  <app-addnew *ngIf="showAddCore" (closeAdd)="getClose($event)" [name]="searchName" 
   (selectedRecordForTypeOfParticipant)=saveAddNew3C($event) [isShared]="isShare" [SendingFor]="sendFrom"
    [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddCore}" >
</app-addnew>

  <app-loader></app-loader>




  

  




